import { Modal } from '@jouzen/ecom-components/v3/Modal';

import Video from '@/app/components/Video/Video';

import type { PopAccuracyComfortSectionData } from './types';

export interface PopAccuracyComfortSectionVideoModalProps {
  readonly isOpen: boolean;
  readonly toggleModal: () => void;
  readonly video: PopAccuracyComfortSectionData['videoFeature'];
}

const PopAccuracyComfortSectionVideoModal = ({
  isOpen,
  toggleModal,
  video,
}: PopAccuracyComfortSectionVideoModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={toggleModal}
      padding="large"
      size="large"
    >
      <div
        className="absolute top-1/2 left-0 aspect-video w-full -translate-y-1/2 px-6 md:relative md:top-0 md:translate-y-0 xl:px-24"
        data-cy="pop-accuracy-comfort-section-video-modal-wrapper"
      >
        <Video
          className="size-full"
          {...video}
          playVideo={isOpen}
          preload="metadata"
        />
      </div>
    </Modal>
  );
};

export default PopAccuracyComfortSectionVideoModal;
